import { render, staticRenderFns } from "./indexTwo.vue?vue&type=template&id=2bc8507f&scoped=true&"
import script from "./indexTwo.vue?vue&type=script&lang=js&"
export * from "./indexTwo.vue?vue&type=script&lang=js&"
import style0 from "./indexTwo.vue?vue&type=style&index=0&id=2bc8507f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc8507f",
  null
  
)

export default component.exports